import { useNavigate, } from 'react-router-dom'

import { ProfileMenuItem } from '../../layouts/Topbar';
import React, { useEffect, useRef } from 'react';
import { PopoverLayout } from './HeadlessUI';
import { RootStateType } from '../../store/RootState';
import { useSelector } from 'react-redux';
import { AUTH_TOKEN, IS_BANK_USER, USER_ID, USER_IDENTITY, USER_NAME_SURNAME } from '../../constants/storageKeys';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faRightFromBracket, faUser } from '@fortawesome/free-solid-svg-icons';
import { useRecoilValue } from 'recoil';
import { tenantState } from '../../store/recoil/tenant/atoms';
import { getUserIdentity } from '../../common/helpers/authorizationHelper';
interface ProfileDropDownProps {
  profiliePic?: string;
}

const profileMenus: ProfileMenuItem[] = [
  {
    label: 'Firma Ayarları',
    icon: <FontAwesomeIcon icon={faGear} />,
    redirectTo: '/parametreler',
  },
  {
    label: 'Profilim',
    icon: <FontAwesomeIcon icon={faUser} />,
    redirectTo: '/profile',
  },
];

const ProfileDropDown = ({ profiliePic }: ProfileDropDownProps) => {


  const { firmInformations } = useRecoilValue(tenantState);
  const firmPath = firmInformations.firmPath;
  const navigate = useNavigate();
  const userIdentity = getUserIdentity();

  const isBankUser = localStorage.getItem(IS_BANK_USER) == "true";

  useEffect(() => {
    if (userIdentity != "ADMIN" || isBankUser) {
      profileMenus.shift();
      if (isBankUser) {
        profileMenus.shift();
      }
    }
  }, [userIdentity])


  const popoverRef = useRef<any>();

  const PopoverToggler = () => {
    return (
      <div className='flex items-center'>
        <img src={profiliePic} alt="user-image" className="rounded-full h-7" />
        <img src="/icons/down-chevron.svg" alt="user-image" className="rounded-full h-[16px] w-[16px]" />
      </div>
    )
  }

  const handleLogout = () => {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem(USER_IDENTITY);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(USER_NAME_SURNAME)

    // navigate("/" + firmPath + "/login");

    window.location.reload();
  }
  const goToMenuItem = (item: ProfileMenuItem) => {
    navigate("/" + firmPath + "" + item.redirectTo);
  }

  return (
    <div className="relative">
      <PopoverLayout popoverRef={popoverRef} placement='bottom-end' toggler={<PopoverToggler />} togglerClass='nav-link' menuClass='w-44 z-50 mt-2 bg-white shadow-lg rounded-lg p-2 border-gray-200 dark:border-gray-700 dark:bg-gray-800'>
        {(profileMenus || []).map((item, idx) => {
          return (
            <React.Fragment key={idx}>
              <a href='#' className="flex items-center py-2 px-3 rounded-md text-sm text-gray-800 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-300"
                onClick={() => goToMenuItem(item)}>
                {item.icon}
                <span className='ml-3 mt-1'>{item.label}</span>
              </a>
            </React.Fragment>
          )
        })}
        {profileMenus.length > 0 && (
          <hr className="my-2 -mx-2 border-gray-200 dark:border-gray-700" />
        )}

        <button className="w-full flex items-center py-2 px-3 rounded-md text-sm text-gray-800 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-300"
          onClick={handleLogout}>
          <FontAwesomeIcon icon={faRightFromBracket} />
          <span className='ml-3  '>Çıkış Yap</span>
        </button>
      </PopoverLayout>
    </div>
  )
}

export default ProfileDropDown